import { Base } from '@studiometa/js-toolkit';
import { addStyle } from '@studiometa/js-toolkit/utils';

/**
 * GForm component to handle label visibility for Gravity Forms
 */
export default class GForm extends Base {
  static config = {
    name: 'GForm',
  };

  /**
   * Component mounted
   */
  mounted() {
    const inputs = this.$el.querySelectorAll('[name]');

    inputs.forEach((input) => {
      const label = document.querySelector(`[for="${input.id}"]`);

      if (
        input &&
        label &&
        (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) &&
        label instanceof HTMLElement
      ) {
        if (!input.getAttribute('placeholder')) {
          input.setAttribute('placeholder', ' ');
        }

        this.toggleLabel(input, label);

        input.addEventListener('input', () => {
          this.toggleLabel(input, label);
        });
      }
    });
  }

  /**
   * Toggle label visibility based on input value
   * @param {HTMLInputElement|HTMLTextAreaElement} input The input element
   * @param {HTMLElement} label The label element
   */
  toggleLabel(input, label) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      return;
    }

    // console.log(input.value.trim());
    if (input.value.trim() !== '') {
      addStyle(label, { opacity: '0' });
    } else {
      addStyle(label, { opacity: '1' });
    }
  }
}
